// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index__disabled__EMtiU {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.index__dragging__1P6UB {\n  opacity: 0.5;\n}\n", "",{"version":3,"sources":["webpack://./src/components/LayoutHeader/exportModal/DragField/index.less"],"names":[],"mappings":"AACA;EACE,mBAAA;EACA,YAAA;AAAF;AAEA;EACE,YAAA;AAAF","sourcesContent":["\n.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.dragging {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabled": "index__disabled__EMtiU",
	"dragging": "index__dragging__1P6UB"
};
export default ___CSS_LOADER_EXPORT___;
